<lib-page-layout>
  <lib-title-navbar pageHeader title="Zmień hasło"></lib-title-navbar>

  <form [formGroup]="passwordForm" class="or-d-flex or-flex-col or-mx-24-px or-mt-24-px">
    <div class="or-head-xs or-color-secondary-2 or-mb-4-px">Obecne hasło</div>
    <input type="password" class="outline-none input-style or-mb-16-px" formControlName="currentPassword" />

    <div class="or-head-xs or-color-secondary-2 or-mb-4-px">Nowe hasło</div>
    <input type="password" class="outline-none input-style" formControlName="newPassword" />
    @if (isNewPasswordTooShort) {
      <div class="or-text-sm or-color-red or-mt-4-px">Hasło musi mieć minimum 6 znaków</div>
    }

    <div class="or-head-xs or-color-secondary-2 or-mb-4-px or-mt-16-px">Powtórz nowe hasło</div>
    <input type="password" class="outline-none input-style" formControlName="confirmPassword" />
    @if (isConfirmMismatch) {
      <div class="or-text-sm or-color-red or-mt-4-px">Hasła nie są takie same</div>
    }
  </form>

  <lib-page-actions pageActions>
    <button
      [disabled]="!passwordForm.valid"
      (click)="changePassword()"
      class="button-primary-style or-color-white or-h-48-px or-w-100-pc or-head-md"
      [ngClass]="{ 'disabled-button': !passwordForm.valid }">
      Zapisz nowe hasło
    </button>
  </lib-page-actions>
</lib-page-layout>
